export default "__VITE_ASSET__1GPaNDa9__"